import React from 'react'

import { useFullScreenState } from './FullScreenContext'
import Separator from '../Separator'

const FullScreenContent = ({ children }) => {
  const { isFullScreen } = useFullScreenState()

  return (
    <Separator
      id="fullScreenContent"
      weight={!isFullScreen ? 0 : 4}
      minHeight="100%"
      bgColor={isFullScreen && 'white'}
      usePadding
    >
      {children}
    </Separator>
  )
}

export default FullScreenContent
